import { render, staticRenderFns } from "./PicZoomWithText.vue?vue&type=template&id=7260246d&scoped=true&"
import script from "./PicZoomWithText.vue?vue&type=script&lang=js&"
export * from "./PicZoomWithText.vue?vue&type=script&lang=js&"
import style0 from "./PicZoomWithText.vue?vue&type=style&index=0&id=7260246d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7260246d",
  null
  
)

export default component.exports